var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFmpiViewEntries(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 600 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#d1315c;}.cls-2{fill:#f384a1;}.cls-3{fill:#fce3f1;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fmpi_view_entries"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 219.04,
    width: 380.96,
    height: 447.85,
    rx: 16.79
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 108.97,
    y: 74.66,
    width: 380.96,
    height: 447.85,
    rx: 16.79
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M381,269.13v314A17,17,0,0,1,363.71,600H17.25A17,17,0,0,1,0,583.16V169a17,17,0,0,1,17.25-16.84H261.07a18,18,0,0,1,5.85,1l112.49,109A16.47,16.47,0,0,1,381,269.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M379.41,262.16H284.36a17.27,17.27,0,0,1-17.44-17.08V153.14Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 55.63,
    y: 371.43,
    width: 262.26,
    height: 36.54,
    rx: 12,
    transform: "translate(-2.96 1.43) rotate(-0.44)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 56.75,
    y: 518.08,
    width: 133.75,
    height: 36.54,
    rx: 12,
    transform: "translate(-4.07 0.96) rotate(-0.44)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 55.07,
    y: 298.34,
    width: 262.26,
    height: 36.54,
    rx: 12,
    transform: "translate(-2.4 1.42) rotate(-0.44)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 56.19,
    y: 444.51,
    width: 261.49,
    height: 36.54,
    rx: 12,
    transform: "translate(-3.51 1.43) rotate(-0.44)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFmpiViewEntries);
export default __webpack_public_path__ + "static/media/fmpi_view_entries.ae6058c5a3d6b306f64bedafb076afc1.svg";
export { ForwardRef as ReactComponent };